import { Component, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NewLoansService } from '../new-loans.service';
import {
  AccountCreationSteps,
  FinancialAccountsCreationService,
  FinancialAccountTypes,
  PatriotActNoticeService,
} from '@brightside-web/desktop/feature/financial-accounts-core';
import { ProductCodes, ProductEligibilityService } from '@brightside-web/desktop/data-access/shared';

@Component({
    selector: 'brightside-web-loan-highlights',
    templateUrl: './loan-highlights.component.html',
    styleUrls: ['./loan-highlights.component.css'],
    standalone: false
})
export class LoanHighlightsComponent {
  private readonly _patriotActNotice = inject(PatriotActNoticeService);

  showHighlightsTwo = false;

  loanHightlightTitleOne = 'LOAN_HIGHLIGHTS_NON_PAYROLL_TITLE';
  loanHightlightDescOne = 'LOAN_HIGHLIGHTS_NON_PAYROLL_DESC';

  loanHightlightTitleTwo = 'LOAN_HIGHLIGHTS_AUTOSAVE_TITLE';
  loanHightlightDescTwo = 'LOAN_HIGHLIGHTS_NO_SAVINGS_DESC';

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private newLoansSvc: NewLoansService,
    private faCreateSvc: FinancialAccountsCreationService,
    private productEligibilitySvc: ProductEligibilityService
  ) {
    if (this.newLoansSvc._cachedCurrentPartnerInfo?.fundsSourceType === 'payroll') {
      this.loanHightlightTitleOne = 'LOAN_HIGHLIGHTS_PAYROLL_TITLE';
      this.loanHightlightDescOne = 'LOAN_HIGHLIGHTS_PAYROLL_DESC';
    }
    if (this.newLoansSvc.hasSavings) {
      this.loanHightlightDescTwo = 'LOAN_HIGHLIGHTS_SAVINGS_DESC';
    }
  }

  routeUser() {
    const proceedToVerification = () => {
      this.nextStep();
    };

    if (!this.newLoansSvc.hasSavings) {
      this._patriotActNotice.continueAfterNoticeIfNeeded(FinancialAccountTypes.SAVINGS, proceedToVerification);
    } else {
      proceedToVerification();
    }
  }

  nextStep() {
    this.faCreateSvc.advanceStep(AccountCreationSteps.INTRO);
    this.router.navigate(['../verification'], { relativeTo: this.route });
  }
}
